const it = {
  // Header / Navigation
  'nav.sports': 'Scommesse Sportive',
  'nav.live': 'Scommesse Live',
  'nav.games': 'Giochi',
  'nav.promotions': 'Promozioni',
  'nav.deposit': 'Deposito',
  'nav.myBets': 'Le mie scommesse',
  'nav.news': 'Notizie',
  'nav.account': 'Conto',
  'nav.login': 'Accedi',
  'nav.register': 'Registrati',
  'nav.logout': 'Esci',

  // Sidebar
  'sidebar.search': 'Squadra, Evento o Competizione',
  'sidebar.quickAccess': 'Accesso Rapido',
  'sidebar.topEvents': 'Eventi Principali',
  'sidebar.topKombis': 'Top Multiple',
  'sidebar.todayMatches': 'Partite di Oggi',
  'sidebar.germanFootball': 'Calcio Tedesco',
  'sidebar.europeanFootball': 'Calcio Europeo',
  'sidebar.topCompetitions': 'Competizioni Top',
  'sidebar.topSports': 'Sport Principali',
  'sidebar.allSports': 'Tutti gli Sport',
  'sidebar.showAllCategories': 'Mostra tutte le categorie',
  'sidebar.hideCategories': 'Nascondi categorie',

  // Sports
  'sport.football': 'Calcio',
  'sport.tennis': 'Tennis',
  'sport.basketball': 'Pallacanestro',
  'sport.iceHockey': 'Hockey su Ghiaccio',
  'sport.handball': 'Pallamano',
  'sport.baseball': 'Baseball',
  'sport.americanFootball': 'Football Americano',
  'sport.boxing': 'Pugilato',
  'sport.cricket': 'Cricket',
  'sport.darts': 'Freccette',
  'sport.rugby': 'Rugby',
  'sport.tableTennis': 'Tennistavolo',
  'sport.beachVolleyball': 'Beach Volley',
  'sport.esports': 'E-Sports',

  // Market Types
  'market.tip': 'Esito',
  'market.tipRemainingTime': 'Tempo Rimanente',
  'market.firstHalf': '1° Tempo',
  'market.overUnder': 'Over/Under',
  'market.doubleChance': 'Doppia Chance',
  'market.bothTeamsScore': 'Entrambe le squadre segnano',

  // Bet Outcomes
  'outcome.fhHomeWinRemainingTime': '1T Vittoria Casa Rim.',
  'outcome.fhDrawRemainingTime': '1T Pareggio Rim.',
  'outcome.fhAwayWinRemainingTime': '1T Vittoria Trasf. Rim.',
  'outcome.fhNextGoalHome': '1T Prossimo Gol Casa',
  'outcome.fhNextGoalAway': '1T Prossimo Gol Trasf.',
  'outcome.nextGoalHome': 'Prossimo Gol Casa',
  'outcome.nextGoalAway': 'Prossimo Gol Trasf.',
  'market.nextGoal': 'Prossimo Gol',
  'outcome.home': 'Casa',
  'outcome.away': 'Trasferta',
  'outcome.homeWin': 'Vittoria Casa',
  'outcome.draw': 'Pareggio',
  'outcome.awayWin': 'Vittoria Trasferta',
  'outcome.over': 'Over',
  'outcome.under': 'Under',
  'outcome.yes': 'Sì',
  'outcome.no': 'No',
  'outcome.fhHomeWin': '1T Vittoria Casa',
  'outcome.fhDraw': '1T Pareggio',
  'outcome.fhAwayWin': '1T Vittoria Trasf.',
  'outcome.fhOver': '1T Over',
  'outcome.fhUnder': '1T Under',
  'outcome.homeWinRemainingTime': 'Vittoria Casa (Rim.)',
  'outcome.drawRemainingTime': 'Pareggio (Rim.)',
  'outcome.awayWinRemainingTime': 'Vittoria Trasf. (Rim.)',

  // Section Titles
  'section.nextGames': 'Prossime Partite',
  'section.topEvents': 'Eventi Principali',
  'section.lastMinute': 'Ultimo Minuto',
  'section.live': 'Live',
  'section.next6Hours': 'Prossime 6 Ore',
  'section.topKombis': 'Top Multiple',
  'section.topKombisSubtitle': 'da altri clienti',
  'section.showAll': 'Mostra tutto',
  'section.createMkPlus': 'Crea MK+',
  'section.viewAll': 'Tutto',

  // Betting Slip
  'slip.title': 'Schedina',
  'slip.empty': 'La tua schedina è vuota.',
  'slip.emptyHint': 'Seleziona le tue scommesse ora.',
  'slip.single': 'Singola',
  'slip.combi': 'Multipla',
  'slip.system': 'Sistema',
  'slip.stake': 'Puntata',
  'slip.totalStake': 'Puntata Totale',
  'slip.setStake': 'Imposta Puntata',
  'slip.totalOdds': 'Quota Totale',
  'slip.potentialWin': 'Vincita Potenziale',
  'slip.placeBet': 'Piazza Scommessa',
  'slip.openBets': 'Scommesse Aperte',
  'slip.viewTicket': 'Visualizza Ticket',
  'slip.noOpenBets': 'Non hai scommesse aperte.',
  'slip.combiBet': 'Scommessa Multipla',
  'slip.singleBet': 'Scommessa Singola',
  'slip.singleBets': 'Scommesse Singole',
  'slip.potentialWinShort': 'Vincita Pot.',
  'slip.maxWin': 'Vincita Max.',
  'slip.requestCashout': 'Richiedi Cashout',
  'slip.combinations': 'Combinazioni (Linee)',
  'slip.cashoutValue': 'Valore Cashout',
  'slip.confirmCashout': 'Conferma Cashout',
  'slip.errorRequestingQuote': 'Errore durante la richiesta di quota.',
  'slip.cashoutFailed': 'Cashout fallito.',
  'slip.error.payoutLimitExceeded': 'Limite massimo di vincita superato. Per favore riduci la puntata.',
  'slip.errorPlacingBet': 'Errore durante la piazzamento scommessa.',
  'slip.placementScore': 'Piazzamento :',
  'slip.currentScore': 'Attuale :',
  'slip.placingBet': 'Creazione ticket...',
  'slip.placingWait': 'Attendere prego...',
  'slip.placingBtn': 'Piazzamento...',
  'slip.betSuccess': 'Ticket Approvato',
  'slip.betSuccessDesc': 'La tua scommessa è stata piazzata con successo!',
  'slip.hasLockedBets': 'La tua schedina contiene scommesse bloccate/sospese.',

  // Live
  'live.noEvents': 'Nessun evento live per',
  'live.games': 'Partite',
  'live.sortBy': 'Ordina per :',
  'live.time': 'Ora',
  'live.competition': 'Competizione',
  'live.halfTime': '1° Tempo',
  'live.ht': 'PT',
  'live.ft': 'FT',

  // Time
  'time.today': 'Oggi',
  'time.tomorrow': 'Domani',
  'time.minutes': 'Min',
  'time.hoursShort': 'Ore',

  // Top Kombis Card
  'kombis.betsPlaced': 'Scommesse piazzate',
  'kombis.combi': 'Multipla',
  'kombis.totalOdds': 'Quota Totale',
  'login.failed': 'Accesso non riuscito',
  'login.invalidCredentials': 'Credenziali non valide',

  // Account
  'account.myAccount': 'Il mio Conto',
  'account.loginPrompt': 'Effettua il login per gestire il tuo conto.',
  'account.verification': 'Verifica Conto',
  'account.management': 'Gestione Conto e Limiti',
  'account.transactions': 'Transazioni',
  'account.personalData': 'Dati Personali',
  'account.responsibleGaming': 'Gioco Responsabile',
  'account.meineDaten': 'I miei Dati',
  'account.kontoverifizierung': 'Verifica Conto',
  'account.kontoverwaltung': 'Gestione e Limiti',
  'account.transaktionsverlauf': 'Cronologia Transazioni',
  'account.guthaben': 'Saldo',
  'account.auszahlung': 'Prelievo',
  'account.einstellungen': 'Impostazioni',
  'account.neuigkeiten': 'Notizie',
  'account.apps': 'App Tipico',
  'account.kontakt': 'Contatti',
  'account.abmelden': 'Esci e Disattiva',
  'account.userTabs.personal': 'Dati Utente',
  'account.userTabs.contact': 'Dettagli Contatto',
  'account.userTabs.password': 'Cambia Password',
  'account.fields.name': 'Nome e Cognome :',
  'account.fields.username': 'Nome Utente :',
  'account.fields.birthname': 'Nome di Nascita :',
  'account.fields.birthdate': 'Data di Nascita :',
  'account.fields.email': 'Email :',
  'account.fields.emailChange': 'Cambia Email',
  'account.fields.lugasId': 'ID Giocatore Lugas :',
  'account.underConstruction': 'Questa sezione è ancora in costruzione.',
  'account.supportPlaceholder': 'Descrivi la tua richiesta nel modo più accurato possibile...',
  'account.salutationMr': 'Sig.',
  'account.loginBtn': 'Accedi',
  'account.transactions.title': 'Cronologia Transazioni',
  'account.transactions.type': 'Tipo',
  'account.transactions.amount': 'Importo',
  'account.transactions.status': 'Stato',
  'account.transactions.date': 'Data',
  'account.transactions.id': 'ID Riferimento',
  'account.transactions.noTransactions': 'Nessuna transazione trovata.',
  'account.transactions.deposit': 'Deposito',
  'account.transactions.withdrawal': 'Prelievo',
  'account.transactions.status.completed': 'Riuscito',
  'account.transactions.status.pending': 'In attesa',
  'account.transactions.status.failed': 'Fallito',
  'account.transactions.filter.all': 'Tutti',
  'account.transactions.filter.startDate': 'Dal :',
  'account.transactions.filter.endDate': 'Al :',
  'account.transactions.filter.reset': 'Ripristina',
  'account.balance.title': 'Saldo e Portafoglio',
  'account.balance.total': 'Saldo Totale',
  'account.balance.available': 'Disponibile',
  'account.balance.locked': 'Bloccato',
  'account.balance.realCash': 'Denaro Reale',
  'account.balance.bonusCash': 'Saldo Bonus',
  'account.balance.premiumWallet': 'Portafoglio Premium',
  'account.balance.depositAction': 'Deposita Fondi',
  'account.balance.withdrawAction': 'Preleva Fondi',
  'account.balance.recentActivity': 'Attività Recenti',
  'account.balance.viewAllTransactions': 'Vedi tutte le transazioni',
  'account.notifications.title': 'Notizie e Notifiche',
  'account.notifications.empty': 'Nessuna notifica disponibile.',
  'account.notifications.markAllRead': 'Segna tutte come lette',
  'account.notifications.markRead': 'Segna come letta',
  'account.notifications.viewAll': 'Mostra tutto',
  'account.withdrawal.title': 'Avvia Prelievo',
  'account.withdrawal.selectMethod': 'Seleziona metodo :',
  'account.withdrawal.amount': 'Importo Prelievo',
  'account.withdrawal.enterAmount': 'Inserisci importo',
  'account.withdrawal.availableToWithdraw': 'Saldo prelevabile :',
  'account.withdrawal.submit': 'Richiedi Prelievo',
  'account.withdrawal.processingTime': 'Durata',
  'account.withdrawal.instant': 'Istantaneo',
  'account.withdrawal.bankDays': '1-3 giorni lavorativi',
  'account.withdrawal.successMessage': 'La tua richiesta è stata inoltrata con successo!',
  'account.withdrawal.successSub': 'L\'importo sarà accreditato sul tuo metodo di pagamento a breve.',
  'account.withdrawal.refId': 'ID Riferimento :',
  'account.withdrawal.error.insufficient': 'Saldo insufficiente.',
  'account.withdrawal.error.minimum': 'L\'importo minimo per il prelievo è 10 €.',
  'account.withdrawal.backToWallet': 'Torna al Saldo',

  // Limits & Account Management
  'account.limits.menuTitle': 'Gestione Conto & Limiti',
  'account.limits.restrictedSoon': 'Il tuo conto sarà presto limitato.',
  'account.limits.restrictedSoonDesc': 'Verifica la tua identità per piazzare scommesse, depositare e prelevare.',
  'account.limits.verifyNow': 'Verifica ora',
  'account.limits.limits': 'Limiti',
  'account.limits.limitsDesc': 'La funzione limiti ti consente di imporre limiti giornalieri, settimanali o mensili su depositi, perdite o tempo di gioco.',
  'account.limits.closure': 'Gestione Conto & Autoesclusione',
  'account.limits.closureDesc': 'La funzione di disattivazione ti permette di prenderti una pausa dal gioco o chiudere il conto.',
  'account.limits.history': 'Cronologia Limiti',
  'account.limits.historyDesc': 'Tutti i tuoi limiti impostati, inclusi depositi, perdite e attività di gioco.',
  'account.limits.myLimits': 'I miei limiti',
  'account.limits.lugasDeposit': 'Limite di deposito LUGAS',
  'account.limits.lugasDepositDesc': 'Impostato l\'ultima volta il {date} alle {time}. Possiamo mostrare solo il limite di deposito LUGAS impostato su Tipico.',
  'account.limits.crossOperator': 'Limite trasversale (cross-operator)',
  'account.limits.changeLimit': 'Modifica limite',
  'account.limits.lugasHint': '*Il tuo limite di deposito mensile trasversale è salvato nel sistema nazionale dei limiti (LUGAS). Ogni tentativo di deposito, anche con altri operatori, incide sul limite LUGAS.',
  'account.limits.tipicoLimits': 'Limiti Tipico (opzionale)',
  'account.limits.tipicoLimitsDesc': 'Limiti aggiuntivi validi solo su Tipico.',
  'account.limits.closureTitle': 'Gestione Conto & Autoesclusione',
  'account.limits.closureInfo': 'Puoi disattivare il tuo conto temporaneamente o chiuderlo definitivamente.',
  'account.limits.closurePermTitle': 'Chiudi definitivamente il conto Tipico:',
  'account.limits.closurePermDesc': 'Se desideri chiudere il conto Tipico in modo permanente (senza possibilità di riattivazione), contatta il nostro ',
  'account.limits.closurePermSupport': 'supporto',
  'account.limits.closureTempTitle': 'Disattiva il conto Tipico temporaneamente:',
  'account.limits.closureTempDesc': 'Seleziona un periodo e un motivo qui sotto. Al termine del periodo, il conto sarà riattivato automaticamente. I conti disattivati temporaneamente possono essere riattivati in qualsiasi momento.',
  'account.limits.closureCrossTitle': 'Autoesclusione trasversale:',
  'account.limits.closureCrossDesc': 'Se desideri autoescluderti dal gioco per prevenire la dipendenza, seleziona l\'opzione ',
  'account.limits.closureCrossOpt': 'Autoesclusione',
  'account.limits.timePeriod': 'Periodo:',
  'account.limits.reason': 'Motivo:',
  'account.limits.chooseOption': 'Scegli opzione...',
  'account.limits.edit': 'Modifica',
  'account.limits.historyTitle': 'Cronologia limiti',
  'account.limits.tabLugas': 'Limite Lugas',
  'account.limits.tabSports': 'Limiti sportivi',
  'account.limits.monthlyDeposit': 'Limite deposito mensile',

  // Balances
  'account.balance.sportsBalance': 'Saldo sport',
  'account.balance.sportsBalanceDesc': 'Questo importo può essere scommesso sullo Sport.',
  'account.balance.withdrawable': 'Prelevabile',
  'account.balance.withdrawableDesc': 'Importo totale disponibile per un prelievo.',
  'account.balance.depositWagering': 'Scommessa deposito',
  'account.balance.depositWageringDesc': 'L\'importo che deve essere scommesso prima di poter essere prelevato. I depositi devono essere scommessi almeno una volta prima di poterli prelevare.',
  'account.balance.bonusBalanceSports': 'Saldo bonus Sport',
  'account.balance.bonusBalanceSportsDesc': 'Questo importo è limitato e può essere utilizzato solo in altri prodotti Tipico o prelevato una volta soddisfatti i requisiti di scommessa del bonus.',

  // Settings
  'account.settings.general': 'Generale',
  'account.settings.language': 'Lingua',
  'account.settings.timeZone': 'Fuso orario',
  'account.settings.showAccountBalance': 'Mostra saldo conto',
  'account.settings.betting': 'Scommesse',
  'account.settings.oddsChanges': 'Cambiamenti di quote',
  'account.settings.oddsChangesDesc': 'Accetta automaticamente i cambiamenti di quote (quote maggiori e minori)',
  'account.settings.communication': 'Comunicazione',
  'account.settings.communicationGroup': 'Comunicazione',

  // Verification
  'account.verification.title': 'Verifica la tua identità',
  'account.verification.subtitle': 'Basta scattare foto del tuo documento d\'identità e un selfie.',
  'account.verification.haveReady': 'Tieni a portata di mano uno dei seguenti documenti:',
  'account.verification.idCard': 'Carta d\'identità',
  'account.verification.passport': 'Passaporto',
  'account.verification.residencePermit': 'Permesso di soggiorno',
  'account.verification.showAllMethods': 'Mostra tutti i metodi',
  'account.verification.dataProtection': 'I tuoi dati sono protetti e utilizzati solo a scopo di verifica.',
  'account.verification.letsGo': 'Iniziamo',

  // Login/Register
  'auth.loginTitle': 'Accedi',
  'auth.registerTitle': 'Registrati',
  'auth.email': 'Email',
  'auth.username': 'Nome utente',
  'auth.password': 'Password',
  'auth.confirmPassword': 'Conferma password',
  'auth.noAccount': 'Non hai ancora un conto?',
  'auth.hasAccount': 'Hai già un conto?',
  'auth.welcomeTitle': 'Tuffati nel mondo delle scommesse!',
  'auth.bonusTitle': 'Raddoppia il tuo primo deposito',
  'auth.bonusSubtitle': 'fino a 100 €',
  'auth.registrationOnlyGermany': 'La registrazione è disponibile solo dalla Germania.',

  // My Bets
  'bets.myBets': 'Le mie Scommesse',
  'bets.active': 'Attive',
  'bets.settled': 'Concluse',
  'bets.won': 'Vinte',
  'bets.lost': 'Perse',
  'bets.pending': 'In sospeso',

  // Misc
  'match.mainBets': 'Scommesse Principali',
  'match.allBets': 'Tutte le Scommesse',
  'misc.noOdds': 'Nessuna quota',
  'misc.matches': 'Partite',
  'misc.matchKombi': 'MatchCombo+',
  'misc.outrights': 'Antepost',
  'misc.statistics': 'Statistiche',
  'misc.search': 'Cerca',
  'misc.close': 'Chiudi',
  'misc.load_more': 'Carica altro',
  'misc.back': 'Indietro',
  'misc.events': 'Eventi',
  'misc.topCompetitions': 'Competizioni Top',
  'misc.noMatches': 'Nessuna partita da mostrare.',
  'misc.loading': 'Caricamento…',
  'misc.confirmColon': 'Conferma :',
  'misc.confirm': 'Conferma',
  'misc.cancel': 'Annulla',
  'misc.error': 'Errore.',

  // Casino
  'casino.title': 'Casinò',
  'casino.games': 'Giochi di Casinò',
  'casino.login_required': 'Effettua l\'accesso o registrati per accedere alla sezione Casinò.',
  'casino.login_btn': 'Accedi',
  'casino.search': 'Cerca giochi...',
  'casino.search_placeholder': 'Nome del gioco...',
  'casino.all_providers': 'Tutti i fornitori',
  'casino.unavailable': 'Il casinò non è al momento disponibile.',
  'casino.load_failed': 'Impossibile caricare i giochi del casinò.',
  'casino.not_found': 'Nessun gioco trovato.',
  'casino.launch_error': 'Impossibile avviare il gioco:',
};

export default it;
